import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Other imports like React, ReactDOM, App...
import App from './IOSGallery'; 
import registerServiceWorker from './serviceWorkerRegistration'; // 👈 USE THIS IMPORT

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Call the function you just imported
registerServiceWorker(); // 👈 ADD THIS LINE